module.exports = __webpack_public_path__ + "img/monitoring-bulldozer-blue.c92244ef.svg";